import * as React from "react"
import { cn } from "@/lib/utils"

function Label({ className, ...props }: React.ComponentProps<"label">) {
  return <label data-slot="label" className={cn("text-sm leading-none font-medium select-none peer-disabled:opacity-50", className)} {...props} />
}

export { Label }
